class UserPreferencesConfig
{
    readonly showMappingColumnValue = "Mapping";
    readonly showOwnerColumnValue = "Owner";
    readonly showCategoryColumnValue = "Category";
    readonly showLastViewedColumnValue = "Last Viewed";
    readonly showViewsColumnValue = "Views";

    showTabs: boolean;

    showWorkbooksMode: ShowWorkbooksModeEnum;
    showWorkbooksType: ShowWorkbooksTypeEnum;
    workbookOpeningMode: WorkbookOpeningModeEnum;

    /// <summary>
    /// None, Mapping, Owner, Category
    /// </summary>
    workbookGrouping: HomeWorkbookGroupingEnum;
    sortColumn: string;
    sortOrder: string;
    sortByFavoriteOrder: boolean;
    showMappingColumn: boolean;
    showOwnerColumn: boolean;
    showCategoryColumn: boolean;
    showLastViewedColumn: boolean;
    showViewsColumn: boolean;

    get showColumns() {
        let columns: Array<string> = [];
        if (this.showMappingColumn) {
            columns.push(this.showMappingColumnValue);
        }
        if (this.showOwnerColumn) {
            columns.push(this.showOwnerColumnValue);
        }
        if (this.showCategoryColumn) {
            columns.push(this.showCategoryColumnValue);
        }
        if (this.showLastViewedColumn) {
            columns.push(this.showLastViewedColumnValue);
        }
        if (this.showViewsColumn) {
            columns.push(this.showViewsColumnValue);
        }

        return columns;
    }
    set showColumns(value: Array<string>) {
        this.showMappingColumn = value.includes(this.showMappingColumnValue);
        this.showOwnerColumn = value.includes(this.showOwnerColumnValue);
        this.showCategoryColumn = value.includes(this.showCategoryColumnValue);
        this.showLastViewedColumn = value.includes(this.showLastViewedColumnValue);
        this.showViewsColumn = value.includes(this.showViewsColumnValue);
    }

    constructor(data) {
        this.showTabs = data?.showTabs ?? false;
        this.showWorkbooksMode = data?.showWorkbooksMode ?? ShowWorkbooksModeEnum.All;
        this.showWorkbooksType = data?.showWorkbooksType ?? ShowWorkbooksTypeEnum.All;
        this.workbookOpeningMode = data?.workbookOpeningMode ?? WorkbookOpeningModeEnum.View;
        this.workbookGrouping = data?.workbookGrouping ?? HomeWorkbookGroupingEnum.None;
        this.sortColumn = data?.sortColumn ?? "lastViewed";
        this.sortOrder = data?.sortOrder ?? "desc";
        this.sortByFavoriteOrder = data?.sortByFavoriteOrder ?? false;

        this.showMappingColumn = data?.showMappingColumn ?? true;
        this.showOwnerColumn = data?.showOwnerColumn ?? true;
        this.showCategoryColumn = data?.showCategoryColumn ?? true;
        this.showLastViewedColumn = data?.showLastViewedColumn ?? true;
        this.showViewsColumn = data?.showViewsColumn ?? true;
    }

    getColumnsOptions() {
        return [this.showMappingColumnValue, this.showOwnerColumnValue, this.showCategoryColumnValue, this.showLastViewedColumnValue, this.showViewsColumnValue];
    }
}

enum ShowWorkbooksTypeEnum {
    All = 0,
    Mine = 1,
    OtherUsers = 2,
    Shared = 3
}

enum ShowWorkbooksModeEnum {
    All = 0,
    Recent = 1,
    Favorites = 2
}

enum HomeWorkbookGroupingEnum {
    None = "None",
    Mapping = "Mapping",
    Owner = "Owner",
    Category = "Category"
}
